import React from 'react'

interface ModalBodyProps {
  children?: React.ReactNode
  className?: string
  testId?: string
}

/** Scrollable content area of a `Modal` that uses slots (header and footer stay fixed). */
const ModalBody: React.FC<ModalBodyProps> = ({ children, className = '', testId }) => (
  <div className={`flex-1 min-h-0 overflow-y-auto p-4 sm:p-6 ${className}`} data-testid={testId}>
    {children}
  </div>
)

export default ModalBody
